import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, serchSelect } from "@/mixins/index";
import adddisciple from "./components/adddisciple";
export default {
  name: "disciple",
  mixins: [loadMoreList, serchSelect],
  components: {
    adddisciple: adddisciple
  },
  data: function data() {
    return {
      pagingReqFn: "heroSlideshowData",
      pagingReqValue: "",
      paramsData: {
        id: '',
        name: '',
        language: ''
      },
      tableBody: 'discipleTable',
      sortReq: 'heroSlideshowChangeSort'
    };
  },
  activated: function activated() {
    this.getList();
  },
  methods: {
    del: function del(dateList) {
      var _this = this;

      var ids = dateList.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'heroSlideshowDel',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this.getList();
      });
    }
  }
};